import { useEffect, useMemo } from "react";
import { captureSmsInviteFromUrl } from "@utils/smsInvite";
import { parseSmsInviteOpenParams } from "@utils/smsInviteOpen";
import { trackGa } from "@lib/tracker";
import { reportSmsOpened } from "@utils/smsOpened";
import SmsInviteRelayView from "./RelayView";

/**
 * 簡訊邀請中繼頁 `/sms-invite/open`。
 *
 * 簡訊只能放自有網域（電信擋 liff.line.me），本頁負責把客戶帶進瓦斯行自己的 LIFF：
 *   - 進站先把 phone/invite/k/order_id/src 存進 sessionStorage（跨流程攜帶，與 /sms-invite 相同）
 *   - 自動嘗試用 `line://app/{liffId}?liff.state=/sms-invite?…` 自訂 scheme 喚起 LINE（程式導向 https 的
 *     liff.line.me 不會觸發 Universal Link，會卡在 Safari 的 LINE 登入頁），畫面同時給一顆
 *     https 版按鈕，使用者親手點才會穩定開 LINE
 *   - 「在瀏覽器繼續」退回本站 `/sms-invite?liffId=…`（電腦、沒裝 LINE、LINE 開不起來）
 *   - 簡訊沒帶 liffId（瓦斯行沒設 liff_main_id）→ 沒有 LIFF 連結可導，直接走本站落地頁
 *
 * 本頁在 LineLoginProvider 內是旁路（isSmsInviteOpenMode）：不初始化 LIFF、不導登入。
 * 拿到參數之後的畫面與自動開 LINE 在 RelayView（短連結 /s/{token} 共用同一份）。
 */
const SmsInviteOpen = () => {
  const params = useMemo(() => parseSmsInviteOpenParams(), []);

  useEffect(() => {
    captureSmsInviteFromUrl();

    if (params) {
      void reportSmsOpened({ invite: params.invite, order_id: params.order_id, phone: params.phone, k: params.k });
      return;
    }
    trackGa("funnel_step", { funnel: "sms_invite", step: "open_relay", result: "invalid_params" });
    window.location.replace("/sms-invite");
  }, [params]);

  if (!params) return null;
  return <SmsInviteRelayView params={params} />;
};

export default SmsInviteOpen;
